define('SageDotCom/Components/CareerSearchOld',["Pagination",
    "knockout",
    "underscore",
    "eventManager",
    "jqueryChosen",
    "jqueryQuerystring",
    "knockoutChosen"
],
    function ($, ko, _, eventManager) {

        function CareerSearch(scope, seeAllLabel, pageSize, navigator) {
            Object.defineProperties(this, {
                $scope: { enumerable: true, value: $(scope) }
            });

            function CallController() {
                $.getJSON("/api/sagedotcom/CareerSearch/GetCareerSearchData", null, function (data) {
                    if (typeof (data) !== "undefined" && data !== null) {

                        var pageData = [];

                        var view = new CareersViewModel(data.vacancies.Records, data.vacancies.TotalSize, pageData);

                        setPagination(pageData, data.vacancies.Records, view);
                        ko.applyBindings(view);
                        var keywords = $.Querystring("keywords");
                        var func = $.Querystring("function");
                        var country = $.Querystring("country");
                        var city = $.Querystring("city");
                        var page = $.Querystring("page");
                        var hasQuery = false;
                        var hasPage = false;
                        if (typeof (keywords) !== "undefined" && keywords !== null) {
                            view.keywords(keywords);
                            hasQuery = true;
                        }
                        if (typeof (func) !== "undefined" && func !== null) {
                            view.selectedFunction(func);
                            hasQuery = true;
                        }
                        if (typeof (country) !== "undefined" && country !== null) {
                            view.selectedCountry(country);
                            hasQuery = true;
                            if (typeof (city) !== "undefined" && city !== null) {
                                view.selectedLocations(city.split(";"));
                            }
                        }
                        if (typeof (page) !== "undefined" && page !== null) {
                            $('#pagination-container').pagination('go', page);
                            view.page = page;
                            view.hasPage = true;
                            hasPage = true;
                        }
                        if (hasQuery) {
                            view.updateResults();
                        } else if (history.pushState && !hasPage) {
                            history.pushState("", "", "?page=1");
                        }



                    }
                });
            }
            var lastPage = 1;
            function setPagination(pageData, dataSource, view) {
                $('#pagination-container').pagination({
                    dataSource: dataSource,
                    pageSize: pageSize,
                    formatNavigator: '<div class=\'stats\'>' + navigator + '</div>',
                    autoHidePrevious: true,
                    autoHideNext: true,
                    callback: function (data, pagination) {
                        pageData = data;
                        view.jobs(data);
                        var fromNumber = pagination.pageNumber * pagination.pageSize - (pagination.pageSize - 1);
                        var toNumber = data.length < pagination.pageSize ? pagination.totalNumber : pagination.pageNumber * pagination.pageSize;
                        if (toNumber !== 0) {
                            var paginationStatsLabel = navigator.replace("STARTNUMBER", fromNumber + ' - ' + toNumber);
                            paginationStatsLabel = paginationStatsLabel.replace("TOTALNUMBER", pagination.totalNumber);

                            $(".stats", scope).html(paginationStatsLabel);
                        } else {
                            $(".stats", scope).html("");
                        }
                        if (pagination.pageNumber != lastPage) {
                            lastPage = pagination.pageNumber;
                            eventManager.trigger("facet-selected", scope, null, "Page", pagination.pageNumber);
                            $(".career-search").parent().get(0).scrollIntoView();
                        }

                    },
                    afterPageOnClick: function () {
                        pageData = $('#pagination-container').pagination('getSelectedPageData');
                        var pageNum = $('#pagination-container').pagination('getSelectedPageNum');
                        if (history.pushState) {
                            //get the query string re-assign page attr
                            var queryString = location.search;
                            if (queryString.indexOf("page=") !== -1) {
                                queryString = queryString.replace(/page=(\d+)/gi, "page=" + pageNum);
                            }
                            history.pushState("", "", queryString);
                        }
                        view.jobs(pageData);
                        eventManager.trigger("add-aria-labels-to-pagination");
                    },
                    afterNextOnClick: function () {
                        eventManager.trigger("add-aria-labels-to-pagination");
                    },
                    afterPreviousOnClick: function () {
                        eventManager.trigger("add-aria-labels-to-pagination");
                    }
                });
            }
            function CareersViewModel(data, totalSize, pageData) {

                var self = this;
                self.hasPage = false;
                self.page = 1;
                self.seeAll = seeAllLabel + "(" + totalSize + ")";

                self.keywords = ko.observable();
                self.functions = ko.computed(function () {
                    var functions = ko.utils.arrayMap(data, function (item) { return item.Function; });
                    return ko.utils.arrayGetDistinctValues(functions).sort();
                });
                self.countries = ko.computed(function () {
                    var listOfAllCountries = ko.utils.arrayMap(data,
                        function (item) {
                            return { country: item.Country, locations: item.OfficeLocation ? item.OfficeLocation.split(";") : "" };
                        });
                    var uniqueList = [];
                    _.each(listOfAllCountries, function (country) {
                        var filtered = listOfAllCountries.filter(function (item) {
                            return item.country === country.country;
                        });
                        var checkUnique = uniqueList.filter(function (item) {
                            return item.country === country.country;
                        });
                        if (filtered.length > 1 && checkUnique.length === 0) {
                            var locations = [];
                            _.each(filtered,
                                function (item) {
                                    locations = locations.concat(item.locations);
                                });
                            locations = ko.utils.arrayGetDistinctValues(locations).sort();
                            uniqueList.push({ country: country.country, locations: locations });
                        } else if (checkUnique.length === 0) {
                            uniqueList.push({ country: country.country, locations: country.locations });
                        }

                    });
                    return uniqueList;
                });

                self.allJobs = data;
                self.selectedCountry = ko.observable();

                self.selectedFunction = ko.observable();

                self.selectedLocations = ko.observableArray();

                self.selectedCountry.subscribe(function (value) {
                    eventManager.trigger("facet-selected", scope, self.keywords(), "Country", value);
                });
                self.selectedFunction.subscribe(function (value) {
                    eventManager.trigger("facet-selected", scope, self.keywords(), "Function", value);
                });
                self.selectedLocations.subscribe(function (value) {
                    eventManager.trigger("facet-selected", scope, self.keywords(), "Location", value);
                });

                self.locations = ko.computed(function () {
                    var country = self.selectedCountry();
                    var filtered = ko.utils.arrayFirst(self.countries(), function (item) {
                        return item.country === country;
                    });
                    if (!filtered) {
                        return [];
                    } else {
                        return filtered.locations;
                    }
                });
                self.jobs = ko.observableArray(pageData);
                // self.functionSelected = function () {
                //     var func = self.selectedFunction();
                // };
                self.updateResults = function () {
                    var keyword = self.keywords();
                    var func = self.selectedFunction();
                    var country = self.selectedCountry();
                    var locations = self.selectedLocations();
                    var jobs = self.allJobs;
                    var queryString = "?";
                    if (!keyword) {
                    } else {
                        jobs = ko.utils.arrayFilter(jobs,
                            function (item) {
                                return ((item.Description !== null && item.Description.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) ||
                                    (item.Name !== null && item.Name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1));
                            });
                        queryString += "keywords=" + keyword + "&";
                    }
                    if (!func) {
                    } else {
                        jobs = ko.utils.arrayFilter(jobs,
                            function (item) {
                                return item.Function === func;
                            });
                        queryString += "function=" + func + "&";
                    }
                    if (!country) {
                    } else {
                        jobs = ko.utils.arrayFilter(jobs,
                            function (item) {
                                return item.Country === country;
                            });

                        queryString += "country=" + country + "&";
                    }
                    if (locations.length) {
                        jobs = ko.utils.arrayFilter(jobs, function (item) {
                            if (item.OfficeLocation == null) {
                                return false;
                            }

                            var jobLocation = item.OfficeLocation.split(";");
                            return locations.some(function (r) {
                                return jobLocation.indexOf(r) >= 0;
                            });
                        });
                        queryString += "city=" + locations.join(";") + "&";
                    }
                    if (queryString.length > 1 && history.pushState && !self.hasPage) {
                        history.pushState("", "", queryString + "page=1");
                    } else if (queryString.length > 1 && history.pushState && self.hasPage) {
                        history.pushState("", "", queryString + "page=" + self.page);
                    }
                    self.jobs(jobs);
                    //update whole pagination with new data set 
                    setPagination(pageData, ko.toJS(self.jobs()), self);
                    eventManager.trigger("search-triggered", scope, keyword);
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".results").offset().top - 80
                    }, 1000);
                };
                self.showAll = function () {
                    setPagination(pageData, ko.toJS(self.allJobs), self);
                    self.keywords("");
                    self.selectedFunction("");
                    self.selectedCountry("");
                    self.selectedLocations([]);
                    self.jobs(self.allJobs.slice(0, pageSize));
                    if (history.pushState) {
                        history.pushState("", "", "?page=1");
                    }
                    eventManager.trigger("search-triggered", scope, "");
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".results").offset().top - 80
                    }, 1000);
                };
                self.jobSelected = function (job) {
                    var keyword = self.keywords();
                    var func = self.selectedFunction();
                    var country = self.selectedCountry();
                    var locations = self.selectedLocations();

                    var facets = "";
                    if (func) {
                        facets += "Function: " + func + "; ";
                    }
                    if (country) {
                        facets += "Country: " + country + "; ";
                    }
                    if (locations && locations.length >= 1) {
                        facets += "Locations: ";
                        locations.forEach(function (location) {
                            facets += location + ",";
                        });
                    }

                    eventManager.trigger("search-result-selected", scope, keyword, facets, job.Name);
                    window.open(job.Url, '_blank');
                };
            }
            CallController();
        }

        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new CareerSearch(args.scope, args.seeAllLabel, args.pageSize, args.navigator);
        };
    });

